'use client'

import { createContext, useContext, useState, useCallback } from 'react'

interface ActiveCategoryContextValue {
  overrideSlug: string | null
  setOverrideSlug: (slug: string | null) => void
}

const ActiveCategoryContext = createContext<ActiveCategoryContextValue>({
  overrideSlug: null,
  setOverrideSlug: () => {},
})

export function ActiveCategoryProvider({ children }: { children: React.ReactNode }) {
  const [overrideSlug, setOverrideSlugState] = useState<string | null>(null)
  const setOverrideSlug = useCallback((slug: string | null) => {
    setOverrideSlugState(slug)
  }, [])
  return (
    <ActiveCategoryContext.Provider value={{ overrideSlug, setOverrideSlug }}>
      {children}
    </ActiveCategoryContext.Provider>
  )
}

export function useActiveCategoryOverride() {
  return useContext(ActiveCategoryContext)
}
